import { render, staticRenderFns } from "./BadgesList.vue?vue&type=template&id=f45ec132&scoped=true&"
import script from "./BadgesList.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BadgesList.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BadgesList.vue?vue&type=style&index=0&id=f45ec132&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45ec132",
  null
  
)

export default component.exports